import AppThemeProvider from "app/providers/AppThemeProvider";

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "app/App";
import { MaterialUIControllerProvider } from "app/providers";
import { AuthProvider } from "app/providers/authContext";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <AppThemeProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </AppThemeProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
